class DropdownNavigation {
  constructor() {
    this.init();
  }

  init() {
    this.triggers = document.querySelectorAll('.js-dropdown-trigger');
    this.attachEvents();
    this.handleClickOutside();
  }

  attachEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => this.toggleDropdown(e));
    });
  }

  toggleDropdown(event) {
    const trigger = event.currentTarget;
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);

    // Close all other dropdowns
    this.closeAllDropdowns(trigger);

    // Toggle current dropdown
    if (!isExpanded) {
      trigger.setAttribute('aria-expanded', 'true');
      if (content) {
        content.setAttribute('aria-hidden', 'false');
      }
    } else {
      trigger.setAttribute('aria-expanded', 'false');
      if (content) {
        content.setAttribute('aria-hidden', 'true');
      }
    }
  }

  closeAllDropdowns(exceptTrigger = null) {
    this.triggers.forEach(trigger => {
      if (trigger !== exceptTrigger) {
        trigger.setAttribute('aria-expanded', 'false');
        const contentId = trigger.getAttribute('aria-controls');
        const content = document.getElementById(contentId);
        if (content) {
          content.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  handleClickOutside() {
    document.addEventListener('click', (e) => {
      const isClickInside = e.target.closest('.c-dropdown-navigation__item');
      if (!isClickInside) {
        this.closeAllDropdowns();
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DropdownNavigation();
  });
} else {
  new DropdownNavigation();
}
